var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraphIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.9375H16.5625V3.125C16.5625 3.04212 16.5296 2.96263 16.471 2.90403C16.4124 2.84542 16.3329 2.8125 16.25 2.8125H11.875C11.7921 2.8125 11.7126 2.84542 11.654 2.90403C11.5954 2.96263 11.5625 3.04212 11.5625 3.125V6.5625H7.5C7.41712 6.5625 7.33763 6.59542 7.27903 6.65403C7.22042 6.71263 7.1875 6.79212 7.1875 6.875V10.3125H3.75C3.66712 10.3125 3.58763 10.3454 3.52903 10.404C3.47042 10.4626 3.4375 10.5421 3.4375 10.625V15.9375H2.5C2.41712 15.9375 2.33763 15.9704 2.27903 16.029C2.22042 16.0876 2.1875 16.1671 2.1875 16.25C2.1875 16.3329 2.22042 16.4124 2.27903 16.471C2.33763 16.5296 2.41712 16.5625 2.5 16.5625H17.5C17.5829 16.5625 17.6624 16.5296 17.721 16.471C17.7796 16.4124 17.8125 16.3329 17.8125 16.25C17.8125 16.1671 17.7796 16.0876 17.721 16.029C17.6624 15.9704 17.5829 15.9375 17.5 15.9375ZM12.1875 3.4375H15.9375V15.9375H12.1875V3.4375ZM7.8125 7.1875H11.5625V15.9375H7.8125V7.1875ZM4.0625 10.9375H7.1875V15.9375H4.0625V10.9375Z",
    fill: "#4D5F6E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraphIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphIcon.0c9eb58c7de9a6e1f9a25708af13839f.svg";